import React, { Component } from 'react';
import _ from 'lodash';

import {
    WithStyles,
    Theme,
    createStyles,
    Grid,
    Typography,
    FormGroup,
    withStyles,
    Button,
    Card,
    CardContent,
    Paper,
    Avatar,
    ListItem,
    Checkbox,
    FormControlLabel,
    ListItemText
} from '@material-ui/core';


import {
    MoreVert as MoreIcon,
    KeyboardBackspace as BackIcon,
    Close as CloseIcon,
    Add as AddIcon,
} from '@material-ui/icons';

import { MyPATIconButton, MyPATSelect, MyPATDialog } from '../../../common';
import ACLService from '../../../acl/services/aclService';
import ACL from '../../../acl/components/ACL';
import goalManagementService from '../../services/goalManagementService';


const styles = (theme: Theme) => createStyles({
    cardContentRoot: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        '&:first-child': {
            paddingTop: 0
        },
        '&:last-child': {
            paddingBottom: theme.spacing.unit * 2,
        },
    },
    checkBoxMap: {
        paddingBottom: theme.spacing.unit / 2,
        paddingTop: theme.spacing.unit / 2,
    },
    contentData: {
        '& div > span': {
            fontSize: 16,
            color: theme.palette.grey[600],
            lineHeight: '28px'
        }
    },
    pT8: {
        paddingTop: theme.spacing.unit * 2,
    }
});





interface PublishGoalDialogProps extends WithStyles<typeof styles> {
    handleMapToMaster: (unmap: any) => void,
    isDialogOpen: boolean,
    dialogCloseHandler: Function,
    selectedList: any,
    activeCourse: any,
    unmap: any,

}

interface PublishGoalDialogState {
    publishDetail: any,
    unMappedConcepts: any[],
}


class PublishGoalDialog extends Component<PublishGoalDialogProps, PublishGoalDialogState> {
    constructor(props: PublishGoalDialogProps) {
        super(props);
        this.state = {
            publishDetail: {},
            unMappedConcepts: [],
        };
        this.handlePublished = this.handlePublished.bind(this);
    }

    static getDerivedStateFromProps(nextProps: any, prevState: any) {
        if (_.cloneDeep(nextProps.selectedList) != _.cloneDeep(prevState.publishDetail)) {
            let selectedList = nextProps.selectedList;
            let subject: any = selectedList["subject"] ? Object.values(selectedList["subject"]) : [];
            subject = subject.flat('Infinity');
            subject = subject.filter((s: any) => s.masterIDs.length == 0);

            let subSubject: any = selectedList["sub-subject"] ? Object.values(selectedList["sub-subject"]) : [];
            subSubject = subSubject.flat('Infinity');
            subSubject = subSubject.filter((ss: any) => ss.masterIDs.length == 0);


            let chapter: any = selectedList["chapter"] ? Object.values(selectedList["chapter"]) : [];
            chapter = chapter.flat('Infinity');
            chapter = chapter.filter((ch: any) => ch.masterIDs.length == 0);


            let concept: any = selectedList["concept"] ? Object.values(selectedList["concept"]) : [];
            concept = concept.flat('Infinity');
            concept = concept.filter((co: any) => co.masterIDs.length == 0);

            let publishDetail = {
                "subject": subject,
                "sub-subject": subSubject,
                "chapter": chapter,
                "concept": concept
            };

            return {
                publishDetail: publishDetail,
            }
        }
        else
            return null;
    }

    handlePublished() {
        let { activeCourse } = this.props;
        let { unMappedConcepts } = this.state;
        if (!_.isEmpty(activeCourse)) {
            let reqBody = {
                courseId: activeCourse._id,
                unMappedConcepts: unMappedConcepts
            }
            goalManagementService.publishGoal(reqBody)
                .then((res: any) => {
                    if (res) {
                        this.setState({ unMappedConcepts: [] });

                        this.props.dialogCloseHandler(true);
                    }
                })
        }
    }


    handleUnmappedConcepts(id: string, e: any) {
        let { unMappedConcepts } = this.state;
        let isPresent = unMappedConcepts.some(um => um == id)
        if (isPresent) {
            unMappedConcepts = unMappedConcepts.filter(um => um != id);
        } else {
            unMappedConcepts.push(id);
        }
        return this.setState({ unMappedConcepts });
    }

    render() {
        const { classes, isDialogOpen, dialogCloseHandler, activeCourse, unmap } = this.props;
        const { publishDetail, unMappedConcepts } = this.state;

        const otherDialogProps = {
            fullWidth: true,
            maxWidth: 'md',
            scroll: 'body',
        }



        return (
            <MyPATDialog
                dialogHeading="Publish Goal"
                dialogOpen={isDialogOpen}
                otherDialogProps={otherDialogProps}
                onDialogClose={dialogCloseHandler}
                customDialogActions={
                    <>

                            <Button onClick={this.handlePublished} id="publish" color="primary" >
                                Publish
                        </Button>
                        {unmap.length == 0 ? '' :
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => this.props.handleMapToMaster(unmap)}
                            >
                                Map to Master
                            </Button>
                        }
                    </>
                }
            >
                <Card>
                    <CardContent className={classes.cardContentRoot}>
                        <Grid className={classes.contentData} container alignContent="center" alignItems="flex-start">
                            <Grid item xs={12} className={classes.pT8}>
                                <Typography variant="h6" inline>{_.get(activeCourse, 'name', '')}</Typography>

                                <Typography variant="caption">We have found following topics in this.If remains unmapped, new topics will be created in master.</Typography>

                            </Grid>
                            <Grid item xs={12} className={classes.pT8}>
                                <Typography variant="h6">Subjects:</Typography>
                                <Grid container spacing={8}>
                                    <Grid item xs={6}>
                                        {
                                            !_.isEmpty(publishDetail["subject"]) ?
                                                publishDetail["subject"].map((obj: any, i: number) => (
                                                    <Typography key={`subject-${i}`} variant="caption">{`${i + 1}. ${_.get(obj, 'name', '')}`}</Typography>
                                                ))
                                                :
                                                <Typography variant="caption">None</Typography>

                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className={classes.pT8}>
                                <Typography variant="h6">Sub Subjects:</Typography>
                                <Grid container spacing={8}>
                                    <Grid item xs={6}>
                                        {
                                            !_.isEmpty(publishDetail["sub-subject"]) ?
                                                publishDetail["sub-subject"].map((obj: any, i: number) => (
                                                    <Typography key={`subSubject-${i}`} variant="caption">{`${i + 1}. ${_.get(obj, 'name', '')}`}</Typography>

                                                ))
                                                :
                                                <Typography variant="caption">None</Typography>

                                        }

                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className={classes.pT8}>
                                <Typography variant="h6">Chapters:</Typography>
                                <Grid container spacing={8}>
                                    <Grid item xs={6}>
                                        {
                                            !_.isEmpty(publishDetail["chapter"]) ?
                                                publishDetail["chapter"].map((obj: any, i: number) => (
                                                    <Typography key={`chapters-${i}`} variant="caption">{`${i + 1}. ${_.get(obj, 'name', '')}`}</Typography>
                                                ))
                                                :
                                                <Typography variant="caption">None</Typography>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} className={classes.pT8}>
                                <Typography variant="h6">Concepts:</Typography>
                                <Grid container spacing={8}>
                                    <Grid item xs={6}>
                                        {
                                            !_.isEmpty(publishDetail["concept"]) ?
                                                publishDetail["concept"].map((obj: any, i: number) => (
                                                    <Typography key={`concepts-${i}`} variant="caption">{`${i + 1}. ${obj.name}`}</Typography>
                                                )) :
                                                <Typography variant="caption">None</Typography>
                                        }
                                    </Grid>
                                    {
                                        !_.isEmpty(publishDetail["concept"]) &&
                                        <Grid item xs={6}>
                                            <FormGroup>
                                                {publishDetail["concept"].map((conceptType: any, index: number) => (
                                                    _.isEmpty(conceptType["masterIDs"]) &&
                                                    <FormControlLabel
                                                        key={`conceptType-${index}`}
                                                        control={<Checkbox className={classes.checkBoxMap} color="primary" />}
                                                        label="Mark as Dummy"
                                                        value={_.get(conceptType, '_id', '')}
                                                        checked={_.includes(unMappedConcepts, conceptType._id)}
                                                        onChange={this.handleUnmappedConcepts.bind(this, _.get(conceptType, '_id', ''))}
                                                    />

                                                ))}
                                            </FormGroup>
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>

                        </Grid>
                    </CardContent>
                </Card>
            </MyPATDialog>
        )
    }
}


// @ts-ignore
export default withStyles(styles)(PublishGoalDialog);
